import axios, { AxiosError } from 'axios';
import { toast } from 'react-toastify';

const fallbackErrorMessage = 'Oops! Something didn’t go as planned.';
const networkErrorMessage =
  'We’re having trouble reaching our servers. Please check your connection or try again soon.';

export const formatAxiosError = (
  error: AxiosError<{ message?: string | string[] }>,
) => {
  if (axios.isCancel(error)) {
    return '';
  }
  if (error.status === 500) {
    return fallbackErrorMessage;
  }
  if (
    !error.response ||
    (error.status && [502, 503, 504].includes(error.status))
  ) {
    return networkErrorMessage;
  }
  const messages = error.response.data?.message;
  const message = Array.isArray(messages) ? messages.join(', ') : messages;
  return message || fallbackErrorMessage;
};

export const formatApiError = (error: unknown) =>
  error instanceof AxiosError ? formatAxiosError(error) : fallbackErrorMessage;

export const toastApiError = (error: unknown) => {
  const message = formatApiError(error);
  if (message) toast.error(message);
};
